import {HomePage} from './../home/home.page';
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import ArticleCategory from '../../../smoothr-web-app-core/models/ArticleCategory';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {ToOrderButtonComponent} from '../../components/to-order-button/to-order-button.component';
import {AlertController, IonSearchbar, ModalController} from '@ionic/angular';
import {ModalInfoComponent} from '../../components/modal-info/modal-info.component';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import {AppComponent} from '../../app.component';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import * as moment from 'moment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OrderPage} from '../order/order.page';
import {TranslateService} from '@ngx-translate/core';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {OrderType} from '../../../smoothr-web-app-core/enums/OrderType';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {environment} from '../../../environments/environment';
import {
	axiosErrorToMessage,
	defaultsToArticleOption,
	getAvailability,
	numberToCurrency,
	sleep
} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {FiltersMenuComponent} from 'src/app/components/filters-menu/filters-menu.component';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {ScanQrModal} from 'src/app/components/scan-qr/scan-qr.component';
import {SelectTableModalComponent} from 'src/app/components/select-table-modal/select-table-modal.component';
import Localization from 'src/smoothr-web-app-core/models/Localization';
import {MapPage} from '../map/map.page';
import {FavouriteModalOnAddComponent} from 'src/app/components/favourite-modal-on-add/favourite-modal-on-add.component';
import {SignUpPage} from '../sign-up/sign-up.page';
import {filter, takeUntil} from 'rxjs/operators';

export enum SelectedFilter {
	CATEGORY = 'category',
	FILTER = 'filter',
	SEARCH = 'search'
}
@Component({
	selector: 'app-menu',
	templateUrl: './menu.page.html',
	styleUrls: ['menu.page.scss']
})
export class MenuPage extends RepositoryDirective implements OnInit, OnDestroy, AfterViewInit {
	static url = 'menu';
	private onDestroy$ = new Subject();
	@ViewChild(ToOrderButtonComponent, {static: false}) toOrderButton;
	@ViewChild('articleContent', {static: false}) articleList;
	@ViewChild(IonSearchbar, {static: false}) searchBar;
	@ViewChild('categoryList', {static: false}) categoryList;

	environment = environment;
	scrollEvents = true;
	loading = false;
	searchTerm = '';
	categories: ArticleCategory[] = [];
	moment = moment;
	PreorderType = PreorderType;
	searchBarOpen = false;
	public selectedHeaderFilter$ = new BehaviorSubject<SelectedFilter | null>(null);
	public selectedFilterEnum = SelectedFilter;
	public categoriesAll: ArticleCategory[] = [];
	public selectedCategory$ = new BehaviorSubject<String | null>(null);
	selectedCategoryName: Localization = null;
	public subscriptionUser = this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription) ?? [];
	public filtersSelected$ = new BehaviorSubject<string[]>([]);
	public isLargeScreen = AppComponent.largeScreen;
	public isTabletScreen = AppComponent.tabletScreen;
	public isOpenBasket$ = new BehaviorSubject<boolean>(false);
	public isSearchbarFocus = false;
	get preorderType(): PreorderType {
		return this.order.preorder?.type;
	}

	constructor(
		private translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private router: Router,
		private analytics: AnalyticsService,
		private navigationService: NavigationService
	) {
		super(repository);
		this.repository.customerAuth.pipe(takeUntil(this.onDestroy$)).subscribe(v => {
			if (v) {
				this.subscriptionUser =
					this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription) ?? [];
			}
		});
		AppComponent.largeScreen$.pipe(takeUntil(this.onDestroy$)).subscribe(v => {
			this.isLargeScreen = v;
		});
		AppComponent.tableScreen$.pipe(takeUntil(this.onDestroy$)).subscribe(v => {
			this.isTabletScreen = v;
		});
		this.filtersSelected$.pipe(takeUntil(this.onDestroy$)).subscribe(filtersValue => this.filtersTags(filtersValue));
	}

	private _selectedCategoryIndex = 0;

	get selectedCategoryIndex(): number {
		return this._selectedCategoryIndex;
	}

	set selectedCategoryIndex(value) {
		if (this._selectedCategoryIndex === value) {
			return;
		}
		this._selectedCategoryIndex = value;
		this.scrollTo(value);
	}

	get selectedCategory(): ArticleCategory {
		return this.categories[this.selectedCategoryIndex];
	}

	get active(): boolean {
		return (
			this.order &&
			(this.order.orderedArticles.length > 0 ||
				this.order.orderedSubscriptionArticles.length > 0 ||
				this.order.subscriptions.length > 0)
		);
	}

	get index(): number {
		return this.categories.findIndex(category => category._id === this.selectedCategory._id);
	}

	get price(): number {
		if (!this.order) {
			return 0;
		}

		return OrderUtils.articleGroupsWithSubscriptionTotalPrice(
			this.order.orderedArticles,
			this.order.orderedSubscriptionArticles,
			this.order.subscriptions,
			this.order.type,
			this.order.preorder.type,
			this.order.terminalorder ? this.order.terminalorder.type : null,
			(this.order.subscriptions ?? []).concat(this.subscriptionUser)
		);
	}

	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}

	// static async navigate(router: Router) {
	// 	await router.navigateByUrl(MenuPage.url);
	// }

	async ngOnInit() {
		await super.ngOnInit();
		switch (window.location.pathname) {
			case '/' + NAVIGATIONURLS.order():
				break;
			case '/' + NAVIGATIONURLS.paymentCancel():
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000
				});
				break;
			case '/' + NAVIGATIONURLS.paymentFail():
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000
				});
				break;
		}

		this.loading = true;
		this.repository.venue.emit(
			await this.repository.getVenue(
				this.order && this.order.venue ? this.order.venue : environment.customerGroup + '_master'
			)
		);
		this.openQrScan(this.venue);
		this.laodAllCategories();
		this.loading = false;
		setTimeout(() => {
			this.searchBar?.setFocus();
		}, 150);
	}
	ngAfterViewInit() {
		this.laodAllCategories();
	}
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	largeScreen(): boolean {
		return AppComponent.largeScreen;
	}

	async scrollTo(index: number) {
		if (this.categories.length - 1 < index || index < 0) {
			return;
		}
		if (this.searchTerm !== '') {
			await sleep(100);
			await this.scrollTo(index);
			return;
		}
		this.scrollEvents = false;
		if (this.selectedCategoryIndex !== index) {
			this.selectedCategoryIndex = index;
			await this.scrollArticleListTo(index);
			await this.scrollCategoryListTo(index);
		}
		this.scrollEvents = true;
	}

	async onScroll(event) {
		const categoryElements = [...this.articleList.el.children];
		const categoryIndex = categoryElements
			.map(el => (this.isLargeScreen ? el.offsetTop : el.offsetTop))
			.map((value, index, array) => {
				return (
					value <= event.detail.currentY &&
					((index < array.length - 1 && event.detail.currentY < array[index + 1]) || index === array.length - 1)
				);
			})
			.findIndex(value => value);
		let prevIndex = -1;
		if (this.selectedCategory) {
			prevIndex = this.categories.findIndex(category => category._id === this.selectedCategory._id);
		}
		if (prevIndex === categoryIndex) {
			return;
		}
		if (this.scrollEvents) {
			this.selectedCategoryIndex = categoryIndex;
			await this.scrollCategoryListTo(categoryIndex);
		}
	}

	private async scrollCategoryListTo(index: number) {
		if (
			index < 0 ||
			!this.categoryList?.nativeElement?.children[index] ||
			(!this.categoryList?.nativeElement?.scrollTo && !this.categoryList?.nativeElement?.scrollLeft)
		) {
			return;
		}
		this.categoryList.nativeElement.scrollTo(this.categoryList.nativeElement.children[index].offsetLeft - 25, 0);
		await sleep(100);
	}

	async openModal(item: Article, notShowModal: boolean = false, category?: ArticleCategory) {
		if (this.loading) {
			return;
		}
		if (this.order && this.order.tableNumber === 'preorder_table' && this.order.preorder.type === PreorderType.INSIDE) {
			this.openQrScan(this.venue);
			return;
		}
		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(
			...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type)
		);
		articleGroup.quantity = 1;
		const foundedArticleInSubscription = (this.repository?._customerAuth?.subscription ?? []).find(
			it => it?.subscription?.articles.includes(articleGroup.article._id)
		);
		if (
			foundedArticleInSubscription &&
			foundedArticleInSubscription?.subscription?.maxOrdersPerDay &&
			foundedArticleInSubscription?.numberOfTimesRedeemed
				? foundedArticleInSubscription?.numberOfTimesRedeemed <
				  foundedArticleInSubscription?.subscription?.maxOrdersPerDay
				: true
		) {
			articleGroup.subscription = foundedArticleInSubscription?.subscription?._id;
		}
		if (notShowModal && !articleGroup.article?.groups?.length) {
			this.addToOrderArticleGroup(articleGroup);
			return;
		}
		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal ' : 'item-modal modal-info',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
				categoryName: category?.name
			},
			mode: 'ios',
			backdropDismiss: true
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response.data && response.data.articleGroup) {
			this.addToOrderArticleGroup(response.data.articleGroup);
		}
	}
	async actionWithArticle(article: Article, action: string) {
		if (
			article &&
			this.order &&
			(this.order.orderedArticles.length > 0 || this.order.orderedSubscriptionArticles.length > 0)
		) {
			switch (action) {
				case 'add':
					const foundArticle = this.order.orderedArticles.find(it => it.article._id === article._id);
					if (foundArticle && foundArticle?.groups?.length > 0) {
						this.openModal(foundArticle.article);
						return;
					}
					this.order.orderedArticles = this.order.orderedArticles.map(it => {
						if (it.article._id == article._id) {
							it.quantity = it.quantity + 1;
						}
						return it;
					});
					this.order.orderedSubscriptionArticles = this.order.orderedSubscriptionArticles.map(it => {
						if (it.article._id == article._id) {
							it.quantity = it.quantity + 1;
						}
						return it;
					});
					break;
				case 'remove':
					this.order.orderedArticles = this.order.orderedArticles
						.map(it => {
							if (it.article._id == article._id && it.quantity > 1) {
								it.quantity = it.quantity - 1;
							} else if (it.article._id == article._id && it.quantity === 1) {
								it = null;
							}
							return it;
						})
						.filter(it => !!it);
					this.order.orderedSubscriptionArticles = this.order.orderedSubscriptionArticles
						.map(it => {
							if (it.article._id == article._id && it.quantity > 1) {
								it.quantity = it.quantity - 1;
							} else if (it.article._id == article._id && it.quantity === 1) {
								it = null;
							}
							return it;
						})
						.filter(it => !!it);
					break;
				default:
					break;
			}

			this.repository.order.emit(this.order);
		} else {
			return;
		}
	}
	addToOrderArticleGroup(articleGroup: ArticleGroup) {
		const subsriptionWithArticle = (this.order.subscriptions ?? [])
			.concat(this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription))
			.find(it => it.articles.includes(articleGroup.article._id));
		// console.log('ADD ARTICLE', articleGroup);
		// if (subsriptionWithArticle) {
		// 	OrderUtils.addToOrder(this.order, articleGroup, this.analytics, true);
		// 	this.repository.order.emit(this.order);
		// 	return;
		// }
		OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
		this.repository.order.emit(this.order);
	}
	onSearchTermChanged(event) {
		this.searchTerm = event.detail.value;
		this.reloadCategories();
	}
	showFocusInput(value: boolean) {
		this.isSearchbarFocus = value;
	}
	laodAllCategories() {
		if (!this.venue) {
			this.categories = [];
			return;
		}

		this.categoriesAll = this.venue.articleCategories
			.filter(category => !category.hidden)
			.map(category => {
				const cat: ArticleCategory = JSON.parse(JSON.stringify(category));
				cat.articles = cat.articles.filter(article => {
					const available = getAvailability(article, OrderType.PREORDER, this.preorderType);
					return available;
				});
				return cat;
			})
			.filter(category => category.articles.length > 0);
	}
	reloadCategories() {
		if (!this.venue) {
			this.categories = [];
			this.loading = false;

			return;
		}
		const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;
		this.categories = this.venue.articleCategories
			.filter(category => !category.hidden)
			.map(category => {
				const cat: ArticleCategory = JSON.parse(JSON.stringify(category));
				cat.articles = cat.articles.filter(article => {
					const available = getAvailability(article, OrderType.PREORDER, this.preorderType);
					if (lowerSearchTerm) {
						const keys = [
							article.name.de.toLocaleLowerCase(),
							article.name.en.toLocaleLowerCase(),
							article.description.de.toLocaleLowerCase(),
							article.description.en.toLocaleLowerCase(),
							article.shortDescription.de.toLocaleLowerCase(),
							article.shortDescription.en.toLocaleLowerCase(),
							// article?.plu?.toLocaleLowerCase(),
							cat.name.de.toLocaleLowerCase(),
							cat.name.en.toLocaleLowerCase()
						];
						return available && keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
					}
					return available;
				});
				return cat;
			})
			.filter(category => category.articles.length > 0);

		return;
	}

	onVenue() {
		super.onVenue();
		if (!this.venue) {
			this.repository
				.getVenue(this.order && this.order.venue)
				.then(venue => {
					this.repository.venue.emit(venue);
				})
				.catch(_ => {
					this.reloadCategories();
					this.selectedCategoryIndex = 0;
				});
			return;
		}
		this.reloadCategories();
		this.selectedCategoryIndex = 0;
	}
	onVenueError(error) {
		super.onVenueError(error);
		this.snackbarCtrl.open(axiosErrorToMessage(this.translate, error));
		this.loading = false;
		this.snackbarCtrl.open(
			this.translate.instant('menu_page.venue_timed_out'),
			this.translate.instant('menu_page.venue_timed_out_action')
		);
	}

	private async scrollArticleListTo(index: number) {
		if (!this.articleList) {
			return;
		}
		await this.articleList.scrollToPoint(0, this.articleList.el.children[index].offsetTop + 1, 300);
	}
	async goHome() {
		await this.repository.cleanRepository();
		await this.navigationService.home();
	}

	changeSearchbar() {
		this.searchBarOpen = !this.searchBarOpen;
	}

	clearInput() {
		this.searchBarOpen = !this.searchBarOpen;
		this.isSearchbarFocus = false;
		this.searchTerm = '';
		this.reloadCategories();
	}
	async changeSelectedCategory(value: SelectedFilter | null) {
		this.selectedHeaderFilter$.next(value);
		if (!value) {
			this.selectedCategoryName = null;
			this.clearInput();
		}
	}
	filterCategory(event: ArticleCategory | null) {
		const allCategory = JSON.parse(JSON.stringify(this.categoriesAll));
		if (event) {
			this.categories = allCategory.filter(category => category._id === event._id);
			this.selectedCategory$.next(event ? event._id : null);
			this.selectedCategoryName = this.categories[0].name;
		} else {
			this.reloadCategories();
			this.selectedCategoryName = null;
		}
		this.selectedHeaderFilter$.next(null);
	}
	filtersValue(event: {diet: {name: string; value: string}[]; dietType: {name: string; value: string}[]}) {
		this.filtersSelected$.next(event.diet.concat(event.dietType).map(it => it?.value) ?? []);
		this.selectedHeaderFilter$.next(null);
	}
	//functionForFiltersByTag
	filtersTags(data: string[]) {
		if (data.length === 0) {
			this.categories = this.categoriesAll;
			return;
		}
		const allCategory = JSON.parse(JSON.stringify(this.categoriesAll)) as ArticleCategory[];
		let filteredCategories = allCategory;
		this.selectedCategoryName = null;
		filteredCategories = allCategory
			.map(it => {
				it.articles = it.articles.filter(article => this.sortArticle(article, data));
				console.log(it.articles);

				return it;
			})
			.filter(category => category.articles.length > 0);

		if (filteredCategories.length > 0) {
			this.categories = filteredCategories;
		} else {
			this.categories = [];
			// this.reloadCategories();
		}
		this.selectedHeaderFilter$.next(null);
	}
	sortArticle(article: Article, filters: string[]) {
		let filterAll = JSON.parse(JSON.stringify(filters)) as string[];
		if (filterAll.includes('alle')) {
			filterAll.push('vegan');
			filterAll.push('vegetarian');
			filterAll = filterAll.filter(it => it !== 'alle');
		}
		console.log(filterAll);

		return !!(
			(article?.compound?.features &&
				Object.entries(article.compound.features).find(it => filterAll.includes(it[0]) && it[1])) ||
			Object.entries(article.compound.additives).find(it => filterAll.includes(it[0]) && it[1])
		);
	}
	clearFilters() {
		this.filtersSelected$.next([]);
		this.reloadCategories();
	}

	async openQrScan(venue: Venue) {
		if (this.order && this.order.tableNumber === 'preorder_table' && this.order.preorder.type === PreorderType.INSIDE) {
			const table = await ScanQrModal.show(this.modalCtrl, venue);
			await sleep(200);
			if (!table) {
				this.snackbarCtrl.open(this.translate.instant('menu_page.no_table'), null, {
					duration: 2000
				});
				return;
			}
			try {
				this.order.tableNumber = table.number;
				this.order.table = table._id;
				this.repository.order.emit(this.order);
				await SelectTableModalComponent.show(this.modalCtrl, this.order);
			} catch (e) {
				console.error(e);
				this.snackbarCtrl.open(this.translate.instant('menu_page.venue_panic_or_closed'), null, {
					duration: 2000
				});
				return;
			}
		}
	}
	isAricleInSubscription(id: string) {
		if (this.order.subscriptions.length > 0) {
			return this.order.subscriptions
				.concat(this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription))
				.find(it => it?._id === id);
		}
		return this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription).find(it => it._id === id);
	}
	async navigateMap() {
		await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.map(), null);
	}

	checkIfArticleIsFavourite(articleNumber: string): boolean {
		return this.repository.checkIfArticleIsFavourite(articleNumber);
	}

	togleBasket() {
		this.isOpenBasket$.next(!this.isOpenBasket$.value);
	}

	async toMapPage() {
		await this.navigationService.map();
	}

	async openSingnUpModal() {
		const modal = await this.modalCtrl.create({
			cssClass: 'item-modal',
			component: SignUpPage,
			componentProps: {
				sizeLarge: 12,
				modalMode: true
			},
			mode: 'ios',
			backdropDismiss: true
		});
		await modal.present();
	}

	async openFilterModal() {
		const modal = await this.modalCtrl.create({
			cssClass: 'item-modal',
			component: FiltersMenuComponent,
			componentProps: {
				venue: this.venue,
				filterView: SelectedFilter.FILTER,
				categories: this.categoriesAll,
				selectedFilters: this.filtersSelected$.value,
				modalMode: true
			},
			mode: 'ios',
			backdropDismiss: true
		});
		await modal.present();
		const result = (await modal.onDidDismiss()) as {
			data?: {diet: {name: string; value: string}[]; dietType: {name: string; value: string}[]};
		};
		if (result?.data) {
			this.filtersSelected$.next(result.data.diet.concat(result.data.dietType).map(it => it?.value) ?? []);
			// this.filtersValue(result.data);
			return;
		}
	}
	isSelectedTag(value: string) {
		return this.filtersSelected$.value?.find(it => it === value);
	}
	trackByArticle(index: number, item: Article) {
		return item?._id;
	}
	trackByCategories(index: number, item: ArticleCategory) {
		return item?._id;
	}
	buttonsSelectFilter(filter: string) {
		let filterSelectedValue = this.filtersSelected$.value;
		const checkFilterSelected = this.filtersSelected$.value?.find(it => filter === it);
		if (checkFilterSelected) {
			filterSelectedValue = filterSelectedValue.filter(it => it !== filter);
		} else {
			filterSelectedValue.push(filter);
		}
		this.filtersSelected$.next(filterSelectedValue);
	}
	addArticleToFavourite(article: Article) {
		console.log('ADD FAV');
		if (this.favourite && this.favourite?.find(it => it === article?._id)) {
			this.repository.deleteFavourite(article._id);
		} else {
			this.repository.addFavourite(article._id);
			FavouriteModalOnAddComponent.show(this.modalCtrl, article.name);
		}
	}
}
